import * as React from 'react';

import Icon from '@ant-design/icons/lib/components/Icon';

const IUser = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
            <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.0013 9.60678C8.80352 9.60678 7.77821 9.16914 6.92535 8.29384C6.07228 7.41833 5.64575 6.36593 5.64575 5.13664C5.64575 3.90736 6.07228 2.85506 6.92535 1.97977C7.77821 1.10426 8.80352 0.666504 10.0013 0.666504C11.1991 0.666504 12.2244 1.10426 13.0773 1.97977C13.9303 2.85506 14.3569 3.90736 14.3569 5.13664C14.3569 6.36593 13.9303 7.41833 13.0773 8.29384C12.2244 9.16914 11.1991 9.60678 10.0013 9.60678ZM0.667969 19.3332V16.4937C0.667969 15.8683 0.83348 15.2891 1.1645 14.7561C1.49552 14.2231 1.93792 13.8133 2.4917 13.5268C3.72163 12.908 4.96244 12.4438 6.21415 12.1343C7.46585 11.8248 8.72824 11.6701 10.0013 11.6701C11.2744 11.6701 12.5368 11.8248 13.7885 12.1343C15.0402 12.4438 16.281 12.908 17.5109 13.5268C18.0647 13.8133 18.5071 14.2231 18.8381 14.7561C19.1691 15.2891 19.3346 15.8683 19.3346 16.4937V19.3332H0.667969ZM2.53464 17.4174H17.468V16.4937C17.468 16.235 17.395 15.9956 17.2489 15.7753C17.1029 15.5552 16.9048 15.3755 16.6544 15.2363C15.5821 14.6943 14.4889 14.2837 13.3747 14.0044C12.2603 13.7254 11.1358 13.5858 10.0013 13.5858C8.86678 13.5858 7.74232 13.7254 6.62792 14.0044C5.51373 14.2837 4.42049 14.6943 3.34819 15.2363C3.09785 15.3755 2.89967 15.5552 2.75366 15.7753C2.60764 15.9956 2.53464 16.235 2.53464 16.4937V17.4174ZM10.0013 7.69101C10.6857 7.69101 11.2717 7.4409 11.7591 6.94066C12.2465 6.44043 12.4902 5.83909 12.4902 5.13664C12.4902 4.43419 12.2465 3.83285 11.7591 3.33262C11.2717 2.83239 10.6857 2.58228 10.0013 2.58228C9.31686 2.58228 8.73093 2.83239 8.24352 3.33262C7.75612 3.83285 7.51241 4.43419 7.51241 5.13664C7.51241 5.83909 7.75612 6.44043 8.24352 6.94066C8.73093 7.4409 9.31686 7.69101 10.0013 7.69101Z"
              fill="#AEA9B1"
            />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default IUser;
